import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/zh-CN";
import "element-ui/lib/theme-chalk/index.css";
import "./common/style/index.scss";
import "font-awesome/css/font-awesome.css";
import { errorHandler } from "./utilis/errorHandle";

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

Vue.config.errorHandler = function (err, vm, info) {
  errorHandler(err, vm, info);
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
